import { store as IceStore } from '@ice/stark-data'
import { ICE_STORE_KEYS } from './constants'

/** 结算系统内嵌页根路径 */
export const PAY_CENTER_PATH = '/leyo-pay-center/'
export const CASH_WITHDRAW_MANAGEMENT_PATH = '#/cash-withdraw-management'
/** 数据中台内嵌页根路径 */
export const DATA_CENTER_PATH = '/data-center/'
/** 判断是否为微应用内嵌页路径 */
export function isMicroEntryPath(string: string) {
  return [PAY_CENTER_PATH, DATA_CENTER_PATH].includes(string)
}

/**
 * 设置结算系统微应用强制刷新状态
 */
export const setForceReloadLeyoPay = (forceReload: boolean) => {
  IceStore.set(ICE_STORE_KEYS.FORCE_RELOAD_LEYO_PAY, forceReload)
}

/**
 * 获取共享的 Token
 */
export function getBasisToken() {
  return IceStore.get(ICE_STORE_KEYS.BASIS_TOKEN)
}

/**
 * 设置共享的 Token
 */
export function setBasisToken(token: string) {
  IceStore.set(ICE_STORE_KEYS.BASIS_TOKEN, token)
}

/**
 * 获取共享的子系统lptoken
 */
export function getLpToken() {
  return IceStore.get(ICE_STORE_KEYS.LP_TOKEN) || sessionStorage.getItem(ICE_STORE_KEYS.LP_TOKEN)
}

/**
 * 设置共享的子系统lptoken
 */
export function setLpToken(token: string) {
  IceStore.set(ICE_STORE_KEYS.LP_TOKEN, token)
  sessionStorage.setItem(ICE_STORE_KEYS.LP_TOKEN, token)
}

/** 获取scw-token */
export function getScwToken() {
  return IceStore.get(ICE_STORE_KEYS.SCW_TOKEN) || sessionStorage.getItem(ICE_STORE_KEYS.SCW_TOKEN)
}

/** 设置scw-token */
export function setScwToken(token: string) {
  IceStore.set(ICE_STORE_KEYS.SCW_TOKEN, token)
  sessionStorage.setItem(ICE_STORE_KEYS.SCW_TOKEN, token)
}

/** 设置子系统-中台-外部-模式 */
export function setSubSystemDataCenterExternalMode(mode: boolean) {
  IceStore.set(ICE_STORE_KEYS.SUB_SYSTEM_DATA_CENTER_EXTERNAL_MODE, mode)
  sessionStorage.setItem(ICE_STORE_KEYS.SUB_SYSTEM_DATA_CENTER_EXTERNAL_MODE, mode?.toString())
}

/** 获取子系统-中台-外部-模式 */
export function getSubSystemDataCenterExternalMode(): boolean {
  return !!IceStore.get(ICE_STORE_KEYS.SUB_SYSTEM_DATA_CENTER_EXTERNAL_MODE)
}

/** 设置委托申报信息 */
export function setDCApplyInfo(info: Record<string, any>) {
  IceStore.set(ICE_STORE_KEYS.APPLY_INFO, info)
}

// 为了向下兼容，导出 Key
export const BASIS_TOKEN_KEY = ICE_STORE_KEYS.BASIS_TOKEN
export const FORCE_RELOAD_LEYO_PAY_KEY = ICE_STORE_KEYS.FORCE_RELOAD_LEYO_PAY
export const LP_TOKEN_KEY = ICE_STORE_KEYS.LP_TOKEN
export const SUB_SYSTEM_DATA_CENTER_MODE_KEY = ICE_STORE_KEYS.SUB_SYSTEM_DATA_CENTER_EXTERNAL_MODE
